<template>
<a class="relevantLink" :href="url" target="_blank">
  <slot></slot>
  <span class="relevantLink-title">{{ title }}</span>
</a>
</template>

<script>
export default {
  props: {
    title: String,
    url: String
  }
}
</script>



// WEBPACK FOOTER //
// relevantlink.vue?65fd24fc